<template>
    <div class="page-main">
        <div class="right">
            <div class="hot-article">
                <side-block-title name="热门主题词">
                    <a href="javascript:;" class="get-more" @click="changeTpage" v-if="tTotalPage>1"><sync-outlined style="margin-right:3px;" />换一批</a>
                </side-block-title>
                <div class="tags">
                    <a-tag v-for="item in topics" :key="item.topicId" >
                        <router-link :to="getTopicUrl(item.topicName)" style="color:#666">
                        {{item.topicName}}
                        </router-link>
                    </a-tag>
                </div>
            </div>
            <div class="hot-article">
                <side-block-title name="热门论文集">
                    <a href="javascript:;" class="get-more" @click="changeCpage" v-if="cTotalPage>1"><sync-outlined style="margin-right:3px;" />换一批</a>
                </side-block-title>
                <div class="articles">
                    <div class="item" v-for="(item) in collections" :key="item.id">                            
                        <div class="title">
                            <router-link :to="{path:'/collection_detail',query:{id:item.id}}" target="_blank">{{item.name}}</router-link>
                        </div>
                        <div class="date" style="color:#999">{{numWan(item.collectQua)}}人收藏 <a-divider type="vertical" /> {{numWan(item.articleQua)}}篇论文</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main-list">
            <a-tabs :activeKey="activeKey" @change="changeTab" style="padding-top:6px">
                <a-tab-pane key="/essay_collection" tab="论文集">
                </a-tab-pane>
                <a-tab-pane key="/expert_rec" tab="专家推荐">
                </a-tab-pane>
                <a-tab-pane key="/essay_rec" tab="论文推荐">
                </a-tab-pane>
            </a-tabs>
            <router-view />
        </div>
        <div class="clear"></div>
    </div>
</template>

<script>
import { computed, defineComponent, onMounted, reactive, toRefs } from "vue";
import { useRoute, useRouter } from "vue-router";
import SideBlockTitle from "../../components/SideBlockTitle.vue";
import Http from "../../until/http";
import {SyncOutlined} from '@ant-design/icons-vue';
import { numWan } from "../../until/tools";
import qs from 'qs';
export default defineComponent({
    components:{SideBlockTitle,SyncOutlined},
    setup() {

        const state = reactive({
            collections:[],
            cTotalPage:0,
            cPage:1,
            topics:[],
            tTotals:0,
            tPage:1,
            tTotalPage:0
        })

        const route = useRoute();

        const activeKey = computed(()=>{
            return route.path;
        })

        const router = useRouter();

        const getEssayList = (page)=>{
            Http.getInterestEssays({currentPage:page}).then(res=>{
                if(res) {
                    if(res.list) {
                        Object.assign(state,{
                            collections:res.list,
                            cTotalPage:res.page.allPage
                        })
                    }
                }
            });            
        }

        const changeCpage=()=>{
            if(state.cPage===state.cTotalPage) {
                state.cPage=1;
            } else {
                state.cPage+=1;            
            }
            getEssayList(state.cPage);    
        }

        const getTopics = (page)=>{
            Http.getInterestTopics({currentPage:page}).then(res=>{
                if(res) {
                    if(res.list) {
                        Object.assign(state,{
                            topics:res.list,
                            tTotalPage:res.page.allPage
                        })
                    }
                }
            });
        }

        const changeTpage=()=>{
            if(state.tPage===state.tTotalPage) {
                state.tPage=1;
            } else {
                state.tPage+=1;            
            }
            getTopics(state.tPage);    
        }

        const changeTab = (e)=>{
            router.push(e)
        }

        
        const getTopicUrl = (name) =>{
            let query = {
                conditions:JSON.stringify([{keyword:name,type:'topicsName'}]),
                page:1,
                startTime:undefined,
                endTime:undefined,
                skip:Math.random()
            };
            let url = '/essay_filter?'+qs.stringify(query);
            return url;
        }

        onMounted(()=>{
            getEssayList(1);
            getTopics(1)
        })

        return {
            ...toRefs(state),
            changeCpage,
            changeTpage,
            changeTab,
            activeKey,
            numWan,
            getTopicUrl
        }
    }
})
</script>
<style lang="scss" scoped>
/deep/.ant-tabs-nav-container{
    padding-left:20px !important;
   }
</style>